import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { Place, ResponsePayload } from "@/types";
import { fetchPlace } from "./thunk";

export type MapBoundsType = {
  lat_min: number;
  lat_max: number;
  lng_min: number;
  lng_max: number;
};
export interface PlaceState {
  place: Partial<Place>;
  view: Array<any>;
  status: "idle" | "fetching";
  error: string | null;
  pinDetails: any;
  centerCoordinates: any;
  currentMapBounds: MapBoundsType | null;
  scrollPostion: number;
}

const initialState: PlaceState = {
  place: {},
  view: [],
  status: "idle",
  error: "",
  currentMapBounds: null,
  pinDetails: {},
  centerCoordinates: {},
  scrollPostion: 0
};

export const placeSlice = createSlice({
  name: "place",
  initialState,
  reducers: {
    setPinDetails: (state, action) => {
      state.pinDetails = action.payload;
    },
    setMapCenterCoordinates: (state, action) => {
      state.centerCoordinates = action.payload;
    },
    updateMapBounds: (state, action) => {
      state.currentMapBounds = action.payload;
    },
    setScrollPosition: (state, action) => {
      state.scrollPostion = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => ({
        ...state,
        ...action.payload[placeSlice.name]
      }))
      .addCase(fetchPlace.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchPlace.fulfilled, (state, action) => {
        state.place = action.payload ?? {};
        state.status = "idle";
      })
      .addCase(fetchPlace.rejected, (state, action) => {
        const { statusText } = action.payload as ResponsePayload;

        state.status = "idle";
        state.error = statusText;
      });
  }
});

export const {
  setPinDetails,
  setMapCenterCoordinates,
  updateMapBounds,
  setScrollPosition
} = placeSlice.actions;
